import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboSerieEscolarComponent } from './combo-serie-escolar.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboSerieEscolarComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboSerieEscolarComponent]
})
export class ComboSerieEscolarModule { }
